import { render, staticRenderFns } from "./SwiperSmall.vue?vue&type=template&id=9cf9027e&scoped=true"
import script from "./SwiperSmall.vue?vue&type=script&lang=js"
export * from "./SwiperSmall.vue?vue&type=script&lang=js"
import style0 from "./SwiperSmall.vue?vue&type=style&index=0&id=9cf9027e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf9027e",
  null
  
)

export default component.exports